// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup[data-v-016d375a] {\n  background: none;\n}\n.popup-container[data-v-016d375a] {\n  text-align: center;\n}\n.popup-container .close-img[data-v-016d375a] {\n  padding-top: 0.8rem;\n  width: 0.64rem;\n  height: 0.64rem;\n}\n.popup-container .content[data-v-016d375a] {\n  background: white;\n  border-radius: 0.42667rem 0.42667rem 0.42667rem 0.42667rem;\n  overflow: hidden;\n  max-width: 7.86667rem;\n}", ""]);
// Exports
module.exports = exports;
